// threshold values 
export const ERROR_PROJECTNAME = "Project name is required"
export const ERROR_ITEMNAME = "Item name is required"
export const ERROR_UNIT = "Item unit is required"
export const ERROR_THRESHOLD = "Threshold quantity is required"
export const ERROR_STD_CONSUMPTION_PER_MT = "Std consumption is required"
